import React, { useState } from 'react';
import { FiInfo } from 'react-icons/fi';
import { FaTrain } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import Card from '../components/Common/Card';
import Input from '../components/Common/Input';
import Button from '../components/Common/Button';
import styles from './TrainInfoPage.module.css';

const TrainInfoPage: React.FC = () => {
  const navigate = useNavigate();
  const [trainNumber, setTrainNumber] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!trainNumber.trim()) {
      setError('Please enter a train number');
      return;
    }

    if (!/^\d{5}$/.test(trainNumber)) {
      setError('Train number must be 5 digits');
      return;
    }

    setIsLoading(true);
    navigate(`/train-info/${trainNumber}`);
    setIsLoading(false);
  };

  const handleTrainNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 5);
    setTrainNumber(value);
    if (error) setError('');
  };

  return (
    <div className={styles.trainInfoPage}>
      <div className="container">
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            <FaTrain className={styles.titleIcon} />
            Train Information
          </h1>
          <p className={styles.subtitle}>
            Get complete train details including route, schedule, and all stations
          </p>
        </div>

        {/* Form */}
        <Card className={styles.formCard}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <Input
              type="text"
              value={trainNumber}
              onChange={handleTrainNumberChange}
              placeholder="Enter 5-digit train number"
              label="Train Number"
              error={error}
              icon={<FaTrain />}
              fullWidth
              maxLength={5}
              autoFocus
            />

            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              isLoading={isLoading}
            >
              {isLoading ? 'Fetching Info...' : 'Get Train Information'}
            </Button>

            <div className={styles.hint}>
              <p>💡 Enter train number to view complete route and schedule details</p>
            </div>
          </form>
        </Card>

        {/* Info Section */}
        <div className={styles.infoSection}>
          <Card className={styles.infoCard}>
            <h3 className={styles.infoTitle}>What You'll Get</h3>
            <ul className={styles.infoList}>
              <li>Complete train route with all stations</li>
              <li>Arrival and departure timings at each station</li>
              <li>Platform information</li>
              <li>Distance and halt time details</li>
              <li>Train type and running days</li>
            </ul>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TrainInfoPage;